<template>
    <section>
        <v-btn @click="OpenSectionDialog">Add Module</v-btn>
        <v-btn @click="OpenCurriculamDialog">Add Module Details</v-btn>
        <v-btn @click="OpenModuleDialog">Add Module Topics</v-btn>
        <v-btn @click="OpenModuleMaterialDialog">Add Module Study Material</v-btn>
        <app-add-section ref="GetDetailsSection" :dialog='AddSectionDialog' @close='CloseDailog'></app-add-section>
        <app-add-curriculam ref="GetDetailsCurriculam" :dialog='AddCurriculamDialog' @close='CloseDailog'></app-add-curriculam>
        <app-module-topic ref="GetDetailsTopic" :dialog='AddModuleTopic' @close='CloseDailog'></app-module-topic>
        <app-add-material ref="GetDetailsMaterial" :dialog='AddModuleMaterial' @close='CloseDailog'></app-add-material>
        <app-curriculam-section></app-curriculam-section>
  </section>
</template>
<script>

import appAddSection        from '../views/dialogs/AddSection'
import appAddCurriculam     from '../views/dialogs/AddCurriculam'
import appModuleTopic       from '../views/dialogs/AddModuleTopics'
import appCurriculamSection from '../views/tables/CurriculamSection'
import appAddMaterial       from '../views/dialogs/AddCurriculamMaterial'

export default {
    components: {
        appAddSection,
        appAddCurriculam,
        appCurriculamSection,
        appModuleTopic,
        appAddMaterial
    },
    data(){
        return {

            AddCurriculamDialog     : false,
            AddSectionDialog        : false,
            AddModuleTopic          : false,
            AddModuleMaterial       : false
        }
    },
    methods:{
        OpenSectionDialog(){
            this.$refs.GetDetailsSection.GetCourseDetailsList()
            this.AddSectionDialog        = true 
        },
        OpenCurriculamDialog(){
            this.$refs.GetDetailsCurriculam.GetCourseDetailsList()
            this.AddCurriculamDialog        = true 
        },
        OpenModuleDialog(){
            this.$refs.GetDetailsTopic.GetCourseDetailsList()
            this.AddModuleTopic        = true 
        },
        OpenModuleMaterialDialog(){
            this.$refs.GetDetailsMaterial.GetCourseDetailsList()
            this.AddModuleMaterial        = true 
        },
        CloseDailog(){
            
            this.AddCurriculamDialog = false
            this.AddSectionDialog    = false
            this.AddModuleTopic      = false
            this.AddModuleMaterial   = false
        }
    },
    mounted(){
        this.$eventHub.$emit("LOADING",'false')
    }
}
</script>
<style scoped>

</style>